// Browser URL paths for availability settings shared across features and components
// to avoid cross-feature imports.

/** Advanced settings tab — host-wide meeting limits and holidays. */
export const ADVANCED_SETTINGS_PATH = '/app/availability/advanced_settings'

/** Legacy weekly schedules page when settings IA is disabled. */
export const AVAILABILITY_SCHEDULES_PATH = '/app/availability/schedules'

/** Deep link to one schedule. Callers outside `features/availability` cannot reach its
 * `useSchedulesRoutes` context, so they link to this path in a new tab instead. */
export const availabilitySchedulePath = (scheduleId) => (
  scheduleId == null ? AVAILABILITY_SCHEDULES_PATH : `${AVAILABILITY_SCHEDULES_PATH}/${scheduleId}`
)
